var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-reports.de53553c.png","uri@3x": __webpack_public_path__ + "icon-reports.0ff848c7.png","uri@2x": __webpack_public_path__ + "icon-reports.ed36aef5.png",
    width: 20,
    height: 20
});